query GetPackmanagerCustomWorkOrderFields {
  packmanagerCustomWorkOrderFields {
    id
    label
    values {
      id
      description
      indicator
    }
  }
}
